import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/icons/checkcircle.svg'


const _hoisted_1 = { class: "modal-wrapper" }
const _hoisted_2 = { class: "modal-body" }
const _hoisted_3 = { class: "text-container" }
const _hoisted_4 = { class: "text" }
const _hoisted_5 = { class: "text-semi-bold" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock($setup["Modal"], {
    isOpen: $setup.props.isOpen,
    classes: "modal-wrapper",
    showClose: false,
    onClose: $setup.onClose
  }, {
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _cache[2] || (_cache[2] = _createElementVNode("img", {
          class: "icon",
          src: _imports_0
        }, null, -1)),
        _cache[3] || (_cache[3] = _createElementVNode("div", { class: "modal-title bold" }, "Hold request submitted!", -1)),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _cache[0] || (_cache[0] = _createTextVNode("You have successfully submitted a hold request for", -1)),
              _createElementVNode("span", _hoisted_5, " Lot " + _toDisplayString($setup.props?.lot?.lotId.title) + ".", 1)
            ]),
            _cache[1] || (_cache[1] = _createElementVNode("div", { class: "text" }, "We will notify you once your request has been reviewed.", -1))
          ]),
          _createElementVNode("button", {
            class: "button primary",
            type: "submit",
            onClick: $setup.onClose
          }, "Continue browsing")
        ])
      ])
    ]),
    _: 1
  }, 8, ["isOpen"]))
}